import { idParam, ROLES } from "../../../helpers/commons.helpers";

/**
 * Quote route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route contains a `meta` object used by navigation
 * guards and permission checks and some routes include a `beforeEnter` guard
 * that sets the purchase type in the store depending on query parameters.
 *
 * @typedef {Object} QuoteRouteMeta
 * @property {boolean} requiresAuth - When true the route requires authentication.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @typedef {import('vue-router').NavigationGuard} NavigationGuard
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
  {
    path: "/quotes",
    name: "Quotes",
    meta: {
      title: "Quotes",
      requiresAuth: true,
      roles: [
        ROLES.SUPER_ADMIN,
        ROLES.ADMIN,
        ROLES.MANAGER,
        ROLES.USER,
        ROLES.SUPPORT,
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "quotes" */ "@/modules/quotes/pages/Quotes.vue"
      ),
  },
  {
    path: "/quotes/new",
    name: "NewQuote",
    meta: {
      title: "New Quote",
      requiresAuth: true,
      roles: [
        ROLES.SUPER_ADMIN,
        ROLES.ADMIN,
        ROLES.MANAGER,
        ROLES.USER,
        ROLES.SUPPORT,
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "quotes" */ "@/modules/quotes/pages/NewQuote"
      ),
  },
  {
    path: `/quotes/${idParam()}`,
    name: "Quote",
    meta: {
      title: "Quote",
      requiresAuth: true,
      roles: [
        ROLES.SUPER_ADMIN,
        ROLES.ADMIN,
        ROLES.MANAGER,
        ROLES.USER,
        ROLES.SUPPORT,
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "quotes" */ "@/modules/quotes/pages/EditQuote"
      ),
  },
];
